"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
/**
 * Need do to the opposite? See `binToStr.ts`.
 *
 * Taken from https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/btoa
 *
 * Useful to prepare strings with 2-byte unicode chars for btoa().
 */
function strToBin(string) {
    var codeUnits = new Uint16Array(string.length);
    for (var i = 0; i < codeUnits.length; i++) {
        codeUnits[i] = string.charCodeAt(i);
    }
    // TODO: Use ... when TS supports it for Uint8Array
    // see https://github.com/zapier/zapier/pull/39560/commits/f29981a7326a250e1cc738ab65605c9f8a161d46#r414221851
    return lodash_1.spread(String.fromCharCode)(new Uint8Array(codeUnits.buffer));
}
exports.default = strToBin;
